import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-slate-200 bg-white px-4 py-3.5 text-[15px] outline-none transition-colors duration-300 focus:border-navy";

  return (
    <div className="grid min-h-screen place-items-center bg-cloud px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-[28px] border border-slate-100 bg-white p-10 shadow-[0_24px_70px_rgba(11,31,58,0.1)]">
        <Logo />
        <div className="mt-8 flex items-center gap-2 text-teal">
          <LockKey size={20} weight="duotone" />
          <span className="text-xs font-bold uppercase tracking-[0.2em]">Admin Access</span>
        </div>
        <h1 className="mt-3 font-heading text-3xl font-semibold text-navy">Insights CMS</h1>
        <p className="mt-2 text-slate-500">Sign in to manage articles and inquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="mb-2 block text-sm font-medium text-navy">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              className={inputCls}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@founderplus.com"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-navy">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              className={inputCls}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full rounded-full bg-navy px-6 py-3.5 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
